module.exports = __webpack_public_path__ + "static/media/headerImg.767ae443.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/headerImg.png
// module id = 1973
// module chunks = 0